import React, { useCallback, useEffect, useState } from "react";
import styles from "./DirectDebit.module.scss";
import SavedCardIcon from "../../assets/images/bank.svg";
import { Add, ArrowBack } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  closeLoader,
  openLoader,
} from "../../redux/actions/loader/loaderActions";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import { ToastErrorStyles } from "../../constants/toastStyles";
import NewDirectDebit from "./NewDirectDebit/NewDirectDebit";
import DebitCard from "../DebitCard/DebitCard";
import { Get, Post } from "../../api/client";
import { useTimerContext } from "../../hooks/use-timer-context";
import { TrackOrderStatusAction } from "../../redux/actions/orderStatus/orderStatusAction";
import transactpay from "../../assets/images/iconlogo.png";
import nofile from "../../assets/icons/empty-folder.svg";
import passwordimg from "../../assets/icons/password 1.svg";

interface DirectDebitProps {
  saveCards: any;
  reference: string;
  currency: string;
  amount: number;
  email: string;
  address: string;
}
interface Bank {
  name: string;
  value: string;
  imgUrl: string;
}

const PollIdentifier = "Tpay-a9c6cf92-49bc-4e3b-8392-50981e27fc88";

const DirectDebit: React.FC<DirectDebitProps> = ({
  saveCards,
  reference,
  currency,
  address,
  amount,
  email,
}) => {
  type SavedCard = {
    savedCardId: number;
    country: string;
    cardExpiryMonth: string;
    cardExpiryYear: string;
    cardFirstSixDigits: string;
    cardLastFourDigits: string;
    cardType: string;
    cardIssuer: string;
    dateCreated: string;
    appEnvironmentId: number;
    // bank: string;
    // first6: string;
    // last4: string;
  };
  //this is for the mandates savedBankDetails / saved mandates
  type savedBankDetails = {
    savedCardId: number;
    first6: string;
    directDebitId: number;
    bank: string;
    last4: string;
    bankName: string;
    bankCode: string;
    imgUrl: string;
    accountNumber: string;
    mandateCode: string;
  };

  const [step, setStep] = useState(2); //change default to step 2 to skip options
  const [selectedMethod, setSelectedMethod] = useState<string>("debit_bank"); //change default to debit_bank to show options
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showOtpField, setShowOtpField] = useState(false);
  const [banks, setBanks] = useState<Bank[]>([]);

  const {
    timeRemainingInMinutesText,
    startTimer,
    timeRemainingInSeconds,
    hasTimerStarted,
    resetTimer,
  } = useTimerContext();

  const [savedBankDetails, setSavedBankDetails] = useState<savedBankDetails[]>(
    [],
  );
  const [customerName, setCustomerName] = useState("");
  const [hasExistingMandate, sethasExistingMandate] = useState();
  const [showAddMandate, setShowAddMandate] = useState(false);
  const handleAddMandate = () => {
    setShowAddMandate(true);
  };
  //show the active mandate using mandatecode (this shows the first one )
  const [activeBank, setActiveBank] = useState<string | null>(
    savedBankDetails?.[0]?.mandateCode || null,
  );
  const [showDebitCard, setShowDebitCard] = useState(false); // State for rendering DebitCard

  // GET LIST OF BANKS
  const GetBanks = async () => {
    try {
      dispatch(openLoader("default"));
      const res: any = await Get("payment/banks?paymentmethod=transfer");
      const d: any[] = res?.data?.data || [];
      const banks: Bank[] = d.map((x) => ({
        name: x.name,
        value: x.bankCode,
        imgUrl: x.logo,
      }));
      setBanks(banks);
      dispatch(closeLoader());
    } catch (err: any) {
      console.error(err);
      dispatch(closeLoader());
    }
  };

  // Fetch debit banks - history button
  const fetchHistory = async () => {
    if (!email) {
      return;
    }
    dispatch(openLoader("default"));
    try {
      const response: any = await Get(
        `payment/order/direct-debit/history?emailAddress=${email}`,
      );
      // console.log(response.data.directDebitMandates);
      setSavedBankDetails(response.data.directDebitMandates);
      sethasExistingMandate(response.data.hasExistingDebitMandate);
      setCustomerName(response?.data?.customerName);
      // dispatch(saveOrderFeeAction({ data: response.data.data }));
    } catch (error: any) {
      const message =
        error?.response?.data?.Message || error?.response?.data?.message;
      dispatch(
        openToastAndSetContent({
          toastStyles: { background: "red", color: "white" },
          toastContent: message,
        }),
      );
    } finally {
      dispatch(closeLoader());
    }
  };

  // check and compare history and bank list ot get images
  const matchedBankDetails = savedBankDetails?.map((bankDetail) => {
    const matchedBank = banks.find((bank) => bank.name === bankDetail.bankName);
    return {
      ...bankDetail,
      imgUrl: matchedBank ? matchedBank.imgUrl : null, // Attach imgUrl if found
    };
  });

  // to rerender and reassign the active bank
  useEffect(() => {
    if (savedBankDetails?.length > 0) {
      setActiveBank(savedBankDetails[0].mandateCode);
    }
  }, [savedBankDetails]);

  useEffect(() => {
    setOtp("");
  }, [showOtpField]);

  useEffect(() => {
    if (selectedMethod == "debit_bank") {
      GetBanks();
      fetchHistory();
      setActiveBank(matchedBankDetails?.[0]?.mandateCode || null);
    }
    return () => {
      resetTimer();
      sessionStorage.removeItem(PollIdentifier);
    };
  }, [selectedMethod]);

  const handleOtpSubmit = () => {
    setShowSuccessModal(true);
    setShowOtpField(false);
  };

  const dispatch = useDispatch();

  //first step - happens on click of pay button
  const handleDebitBankPay = () => {
    sendOtpToUser(); //to send otp
    // setShowOtpField(true);
  };

  // this send the endpoint and prepares user for pay
  const sendOtpToUser = async () => {
    try {
      dispatch(openLoader("default"));
      let payload = {
        mandateCode: activeBank,
      };
      // console.log(payload);
      const res: any = await Post("/payment/order/direct-debit/otp", payload);
      // console.log(res?.data?.code);
      dispatch(closeLoader());
      res?.data?.code == "00" && setShowOtpField(true); //show the otp field once response is succesful
    } catch (error: any) {
      dispatch(closeLoader());
      const errorMessage =
        error?.response?.data?.Message || error?.response?.data?.message;
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: errorMessage,
        }),
      );
    }
  };

  const pollStatus = async () => {
    let intervalId: NodeJS.Timeout | null = null;

    dispatch(openLoader("default"));
    try {
      intervalId = setInterval(async () => {
        if (!intervalId) {
          return;
        }

        if (!hasTimerStarted) {
          clearInterval(intervalId);
          return;
        }

        if (hasTimerStarted && timeRemainingInSeconds === 1) {
          clearInterval(intervalId);
          return;
        }
        const intervalIdentifierFromStorage =
          sessionStorage.getItem(PollIdentifier);
        if (
          !intervalIdentifierFromStorage ||
          intervalIdentifierFromStorage !== PollIdentifier
        ) {
          clearInterval(intervalId);
          return;
        }
        let payload: Record<string, unknown> = {
          mandateCode: "mandateCode",
        };
        const res: any = await Post(
          "/payment/order/direct-debit/status",
          payload,
        );
        // console.log(res?.data);
      }, 5000);

      const interval = dispatch(closeLoader());
    } catch (error: any) {
      if (intervalId) {
        clearInterval(intervalId);
      }
      dispatch(closeLoader());
      const errorMessage =
        error?.response?.data?.Message || error?.response?.data?.message;
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: errorMessage,
        }),
      );
    }
  };

  const handlePay = async () => {
    // if (!activeCard) return;
    try {
      dispatch(openLoader("default"));
      let payload: Record<string, unknown> = {
        paymentOption: "ndd",
        reference: reference,
        directDebitPaymentRequest: {
          accountName: customerName,
          bankCode:
            matchedBankDetails.find((bank) => bank.mandateCode === activeBank)
              ?.bankCode || "",
          mandateCode:
            matchedBankDetails.find((bank) => bank.mandateCode === activeBank)
              ?.mandateCode || "",
          otp,
        },
      };
      const res: any = await Post("/payment/order/pay", payload);
      if (res?.data?.status === "success") {
        setShowSuccessModal(true);
        startTimer(900);
        TrackOrderStatusAction(
          Statuspayload,
          "directDebit",
          dispatch,
          (data: any) => {
            // console.log({ data });
          },
        );
      }
      dispatch(closeLoader());
      setShowOtpField(false);
    } catch (error: any) {
      dispatch(closeLoader());
      const errorMessage =
        error?.response?.data?.Message || error?.response?.data?.message;
      setShowOtpField(false);
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: errorMessage,
        }),
      );
    }
  };

  //using status actions to poll rather
  const Statuspayload = {
    reference: reference,
    paymentOption: "ndd",
  };

  // Code for otp
  const [otp, setOtp] = useState<string>("");

  const handleOtpChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    if (!value) return;

    let newOtp = otp.split("");
    newOtp[index] = value;
    const updatedOtp = newOtp.join("");
    setOtp(updatedOtp);

    if (value && e.target.nextElementSibling) {
      (e.target.nextElementSibling as HTMLInputElement).focus();
    }
  };

  const handleOtpKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number,
  ) => {
    if (e.key === "Backspace") {
      let newOtp = otp.split("");
      newOtp[index] = "";
      setOtp(newOtp.join(""));

      if (!otp[index] && e.currentTarget.previousElementSibling) {
        (e.currentTarget.previousElementSibling as HTMLInputElement).focus();
      }
    }
  };

  const handleOtpPaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pastedValue = e.clipboardData.getData("text").replace(/[^0-9]/g, "");
    const newOtp = pastedValue.slice(0, 6);
    setOtp(newOtp);

    const inputs = document.querySelectorAll<HTMLInputElement>(".otpInput");
    inputs.forEach((input, idx) => {
      input.value = newOtp[idx] || "";
    });

    if (inputs[newOtp.length - 1]) {
      inputs[newOtp.length - 1].focus();
    }
  };

  const handleSubmit = () => {
    const otpValue = otp; // No need to join since otp is already a string
    handlePay();
  };

  // Code for showing new direct debit mandate
  if (showAddMandate) {
    return (
      <NewDirectDebit
        goBackToDirectdebit={() => setShowAddMandate(false)}
        address={address}
        reference={reference}
        customerName={customerName}
      />
    );
  }
  // Code for showing debit card component if to add new card
  if (showDebitCard) {
    return (
      <DebitCard
        reference={reference}
        currency={currency}
        amount={amount}
        // saveCards={savedCards}
        saveCards={saveCards}
      />
    );
  }

  //Code to show list of banks when needed to select mandate
  const handleSelectBankDetail = (mandateCode: string) => {
    // if (activeBank === mandateCode) return;
    setActiveBank(mandateCode);
  };

  // Back button
  const BackButton = () => (
    <button
      onClick={() => {
        // if (step > 1) {
        //   setStep(step - 1);
        // }
        setOtp(""); // Reset OTP when the input field is shown
        setShowOtpField(false);
      }}
      className={styles.BackButton}
    >
      <ArrowBack style={{ marginRight: "5px", fontSize: "18px" }} />
      Back
    </button>
  );

  return (
    <div className={styles.container}>
      {/* {step > 1 && <BackButton />} */}

      {/* (Default) Step 2: Debit Bank Account (Direct debit / Mandate) */}
      {step === 2 && selectedMethod === "debit_bank" && !showOtpField && (
        <div>
          {/* <PaymentDetailsBox totalAmount={100} fee={20} subtotal={120} /> */}
          <h3 className={styles.title}>
            {hasExistingMandate ? "Select Bank" : "Pay with Trust"}
          </h3>
          <div className={styles.secondarySelectionContainer}>
            {!hasExistingMandate ? (
              <div className={styles.noMandate}>
                <div
                  style={{
                    border: "1px solid #8E173E",
                    padding: "5px",
                    width: "fit-content",
                    borderRadius: "5px",
                    backgroundColor: "#FBE9EF99",
                  }}
                >
                  <img
                    src={nofile}
                    alt="no-saved-account"
                    style={{
                      objectFit: "contain",
                      height: "40px",
                      width: "40px",
                    }}
                  />
                </div>

                <p>No saved accounts found</p>

                <button className={styles.payButton} onClick={handleAddMandate}>
                  Add new bank details
                </button>
              </div>
            ) : (
              //show list of mandates
              <div className={styles.mandateListContainer}>
                {matchedBankDetails?.map((bank) => (
                  <div
                    key={bank.mandateCode}
                    className={`${styles.bankDetails} ${
                      activeBank === bank.mandateCode ? styles.activeBank : ""
                    }`}
                    onClick={() => {
                      handleSelectBankDetail(bank.mandateCode);
                      handleDebitBankPay();
                    }}
                    // onClick={() => {
                    //   handleDebitBankPay();
                    //   if (activeBank !== bank.mandateCode) {
                    //     handleSelectBankDetail(bank.mandateCode);
                    //     handleDebitBankPay();
                    //   }
                    // }}
                  >
                    <div className={styles.bankDetailsInfo}>
                      <div className={styles.bankDetailsIconContainer}>
                        <img
                          src={bank.imgUrl || SavedCardIcon}
                          alt="Bank Icon"
                          className={styles.bankDetailsIcon}
                        />
                      </div>
                      <p style={{ marginBottom: "0px" }}>
                        {bank?.bankName} {""} {bank?.accountNumber}{" "}
                      </p>

                      <p
                        style={{
                          color: "#8E183E",
                          fontSize: "20px",
                          marginLeft: "auto",
                          marginBottom: "0",
                        }}
                      >
                        &#8250;
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* add new mandate starts */}
            {hasExistingMandate && (
              <div className={styles.addbankDetailsContainer}>
                <span
                  className={styles.addbankDetailsText}
                  onClick={handleAddMandate}
                >
                  Add new bank details
                </span>
                <Add
                  className={styles.addbankDetailsIcon}
                  onClick={handleAddMandate}
                />
              </div>
            )}
          </div>
        </div>
      )}

      {/* OTP Input Field */}
      {showOtpField && (
        <div className={styles.otpContainer}>
          <div
            style={{
              border: "1px solid #8E173E",
              padding: "5px",
              width: "fit-content",
              borderRadius: "5px",
              backgroundColor: "#FBE9EF99",
              marginBottom: "10px",
            }}
          >
            <img
              src={passwordimg}
              alt="enter-otp"
              style={{
                objectFit: "contain",
                height: "40px",
                width: "40px",
              }}
            />
          </div>
          <h5 style={{ fontWeight: 600 }}>Enter the OTP sent to {email}</h5>
          <p>
            Payment initiated successfully. Enter the OTP sent to your email to
            complete payment
          </p>
          <div className={styles.secondarySelectionContainer}>
            <div className={styles.otpInputContainer}>
              {Array(6)
                .fill("")
                .map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    inputMode="numeric" // Mobile keyboard optimization
                    maxLength={1}
                    className={styles.otpInput}
                    value={otp[index]} // Controlled input
                    onChange={(e) => handleOtpChange(e, index)}
                    onKeyDown={(e) => handleOtpKeyDown(e, index)}
                    onPaste={handleOtpPaste} // Handle paste event
                  />
                ))}
            </div>
            {/* <button className={styles.resendOtpButton}>Resend OTP</button> */}
          </div>
          <button
            type="button"
            disabled={otp.trim().length < 6}
            className={styles.submitButton}
            onClick={handleSubmit}
          >
            Pay
          </button>
        </div>
      )}

      {/* Success Modal */}
      {showSuccessModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <h3 className={styles.modalTitle}>Order Created Successfully</h3>
            <p>Your payment is being processed.</p>

            <h3 className={styles.modalTitle}>{timeRemainingInMinutesText}</h3>
            <button
              className={styles.modalButton}
              onClick={() => setShowSuccessModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Powered by */}
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className={styles.poweredByBox}>
          <p className={styles.poweredBy}>Powered by</p>
          <img
            src={transactpay}
            style={{ width: "auto", height: "20px", objectFit: "cover" }}
            alt="Transactpay"
          />
        </div>
      </div>
    </div>
  );
};

export default DirectDebit;
